var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { api } from "./api";
// Query keys for league venue operations
var USE_LIST_LEAGUE_HOME_VENUES = "useListLeagueHomeVenues";
// Constants for cache configuration (matching main ApiProvider)
var STALE_TIME = 5 * 60 * 1000; // 5 minutes
var CACHE_TIME = 10 * 60 * 1000; // 10 minutes
// League venue listing hook
export var useListLeagueHomeVenues = function (_a) {
    var leagueId = _a.leagueId, _b = _a.enabled, enabled = _b === void 0 ? true : _b;
    return useQuery({
        queryKey: [USE_LIST_LEAGUE_HOME_VENUES, leagueId],
        queryFn: function () { return __awaiter(void 0, void 0, void 0, function () {
            var data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, api.get("/leagues/".concat(leagueId, "/venues/"))];
                    case 1:
                        data = (_a.sent()).data;
                        return [2 /*return*/, data];
                }
            });
        }); },
        enabled: !!leagueId && enabled,
        staleTime: STALE_TIME,
        cacheTime: CACHE_TIME,
    });
};
export var useAddVenueToLeague = function (_a) {
    var onSuccess = _a.onSuccess, onError = _a.onError, leagueId = _a.leagueId;
    var queryClient = useQueryClient();
    return useMutation({
        mutationFn: function (data) { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, api.post("/league-venues/", data)];
            });
        }); },
        onSuccess: function (data) {
            // Use the leagueId passed as parameter
            if (leagueId) {
                queryClient.invalidateQueries([USE_LIST_LEAGUE_HOME_VENUES, leagueId]);
            }
            onSuccess(data);
        },
        onError: onError,
    });
};
// Deactivate venue hook
export var useDeactivateVenueFromLeague = function (_a) {
    var onSuccess = _a.onSuccess, onError = _a.onError, leagueId = _a.leagueId;
    var queryClient = useQueryClient();
    return useMutation({
        mutationFn: function (_a) { return __awaiter(void 0, void 0, void 0, function () {
            var leagueVenueId = _a.leagueVenueId, data = __rest(_a, ["leagueVenueId"]);
            return __generator(this, function (_b) {
                return [2 /*return*/, api.post("/league-venues/".concat(leagueVenueId, "/deactivate/"), data)];
            });
        }); },
        onSuccess: function (data) {
            // Use the leagueId passed as parameter
            if (leagueId) {
                queryClient.invalidateQueries([USE_LIST_LEAGUE_HOME_VENUES, leagueId]);
            }
            onSuccess(data);
        },
        onError: onError,
    });
};
export var useRemoveVenueFromLeague = function (_a) {
    var onSuccess = _a.onSuccess, onError = _a.onError, leagueId = _a.leagueId;
    var queryClient = useQueryClient();
    return useMutation({
        mutationFn: function (leagueVenueId) { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, api.delete("/league-venues/".concat(leagueVenueId, "/"))];
            });
        }); },
        onSuccess: function () {
            // Use the leagueId passed as parameter
            if (leagueId) {
                queryClient.invalidateQueries([USE_LIST_LEAGUE_HOME_VENUES, leagueId]);
            }
            else {
                queryClient.invalidateQueries([USE_LIST_LEAGUE_HOME_VENUES]);
            }
            onSuccess();
        },
        onError: onError,
    });
};
